export const expressName = {
    'unique':'唯一校验',
    'notnull':'必填校验',
    'lengthgteq':'长度大于等于',
    'lengthlteq':'长度小于等于',
    'lengtheq':'长度等于',
    'lengthlt':'长度小于',
    'lengthgt':'长度大于',
    'eqpropset':'等于属性值集',
    '<':'小于',
    '=':'等于',
    '!=':'不等于',
    '>=':'大于等于',
    '<=':'小于等于',
    'inwithedge':'在某范围内，如[3,10]',
    'inwithoutedge':'在某范围内不包含边界，如(3,10)',
    'any':'枚举',
    'is':'字符串匹配相等',
    '>':'大于',
    'reg':'正则校验',
    'contain':'含有',
    ' ':'组合验证拼接符--空格',
    '/':'组合验证拼接符--斜杠',
    '*':'组合验证拼接符--星号',
    'x':'组合验证拼接符--x',
    '|':'组合验证拼接符--竖线',
    '&':'组合验证拼接符--and',
    '-':'组合验证拼接符--减号',
    '~':'组合验证拼接符--波浪线',
    '+':'组合验证拼接符--加号',
    '、':'组合验证拼接符--中文顿号',
    '_':'组合验证拼接符--下划线',
    ',':'组合验证拼接符--英文逗号',
    '，':'组合验证拼接符--中文逗号',
    '\\':'组合验证拼接符--反斜杠',
    'isnull':'必空校验',
    'iswithoutledge':'在某范围内不包含左边界，如(3,10]',
    'iswithoutredge':'在某范围内不包含右边界，如[3,10)',

}

export default  {
    expressName
}